window.addEventListener("DOMContentLoaded", function () {
    const accessToken = mapbox_env.front_token;
    const mapboxDomain = 'https://api.mapbox.com/';

    const mapboxGeocodingUrl = mapboxDomain + 'geocoding/v5/mapbox.places/';
    const mapboxDirectionUrl = mapboxDomain + 'directions/v5/mapbox/driving/';

    /**
     *
     * @param search_text
     * @param limit
     * @return {Promise<Response>}
     */
    window.mapboxGetGeocodingCoordinatesByText = (search_text, limit) => {
        const mapboxGeocodingSearchUrl = mapboxGeocodingUrl + search_text + '.json?access_token=' + accessToken + '&types=place,address,postcode,poi&country=US&limit=' + limit;
        return fetch(mapboxGeocodingSearchUrl)
    }

    /**
     *
     * @param coordinates
     * @return {Promise<Response>}
     */
    window.mapboxGetDirectionByCoordinates = async (coordinates) => {
        const mapboxGetDirectionUrl = mapboxDirectionUrl + coordinates + '.json?access_token=' + accessToken + '&overview=full';
        const req = await fetch(mapboxGetDirectionUrl);
        return await req.json()
    }
});